import { createRouter, createWebHistory } from 'vue-router';  
import LoginForm from '../components/LoginForm.vue';  
import HomePage from '../components/HomePage.vue';  
import update from '../components/update.vue';  
import search_std from '../components/search_std.vue';  
import applog_info from '../components/applog_info.vue';  
import update_class_info from '../components/update_class_info.vue';  
import update_class_barcode from '../components/update_class_barcode.vue';  
import class_log from '../components/class_log.vue';  
import logout from '../components/logout.vue';  
import upload_logo from '../components/upload_logo.vue';  

const routes = [
  { path: '/login', component: LoginForm },
  {
    path: '/',
    component: HomePage,
    meta: { requireLogin: true },
    children: [
      { path: '/update', component: update },
      { path: '/search', component: search_std },
      { path: '/applog', component: applog_info },
      { path: '/update_class_info', component: update_class_info },
      { path: '/update_class_barcode', component: update_class_barcode },
      { path: '/class_log', component: class_log },
      { path: '/logout', component: logout },
      { path: '/upload_logo', component: upload_logo }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;